import { Button, Form, Modal } from 'antd';

import { AUDIENCE_UNAUTHORIZED_TYPE } from 'constants/distribution';
import { IDistribution } from 'types/distribution.types';
import { DistributionForm } from '../DistributionForm';

export const NewDistributionModal = ({ open, onOk, onCancel, submitting }: any) => {
  const [form] = Form.useForm<IDistribution>();
  const handleReset = () => {
    form.resetFields();
  };
  const handleSubmit = () => {
    form.submit();
  };

  return (
    <Modal
      centered
      title="Создание рассылки"
      open={open}
      onCancel={onCancel}
      cancelText="Закрыть"
      footer={[
        <Button key="reset" type="text" onClick={handleReset}>
          Очистить
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit} loading={submitting}>
          Создать
        </Button>,
      ]}
    >
      <DistributionForm
        onFinish={onOk}
        form={form}
        initialValues={{
          audience: AUDIENCE_UNAUTHORIZED_TYPE,
        }}
      />
    </Modal>
  );
};
